import { render, staticRenderFns } from "./energizerPhotoTagging.vue?vue&type=template&id=2130ab81&scoped=true"
import script from "./energizerPhotoTagging.vue?vue&type=script&lang=js"
export * from "./energizerPhotoTagging.vue?vue&type=script&lang=js"
import style0 from "./energizerPhotoTagging.vue?vue&type=style&index=0&id=2130ab81&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2130ab81",
  null
  
)

export default component.exports